import { HttpClient } from '../httpClient';
import Bonus from '../models/bonus';
import { DataResponse } from '../responses/baseResponse';
import BonusResponse from '../responses/payateResponse';
import BonusRequest from '../requests/bonusRequest';
import BonusFrequency from '../models/bonusFrequency';
import BonusTypes from '../models/bonusTypes';
import RejectWithFeedbackRequest from '../requests/rejectWithFeedbackRequest';

const httpClient = new HttpClient();

export const getBonusById = async (id: any) => {
  return httpClient.get<DataResponse<Bonus>>({
    url: `/v1/Bonus/${id}`,
    requiresToken: true,
  });
};

export const getBonus = async (id: number) => {
  return httpClient.get<BonusResponse>({
    url: `/v1/Bonus/${id}`,
    requiresToken: true,
  });
};

export const getBonuses = async () => {
  return httpClient.get<DataResponse<Bonus[]>>({
    url: '/v1/Bonus',
    requiresToken: true,
  });
};

export const getBonusesByTherapistId = async (id: number) => {
  return httpClient.get<DataResponse<Bonus[]>>({
    url: `/v1/Bonus/ByTherapistId/${id}`,
    requiresToken: true,
  });
};

export const getBonusesByUserId = async (id: number) => {
  return httpClient.get<DataResponse<Bonus[]>>({
    url: `/v1/Bonus/ByUserId/${id}`,
    requiresToken: true,
  });
};

export const createBonus = async (Bonusrequest: BonusRequest) => {
  return httpClient.post<BonusResponse>({
    url: '/v1/admin/Bonus',
    payload: Bonusrequest,
    requiresToken: true,
  });
};

export const updateBonus = async (
  BonusId: number,
  Bonusrequest: BonusRequest
) => {
  return httpClient.put<BonusResponse>({
    url: `/v1/admin/Bonus/${BonusId}`,
    payload: Bonusrequest,
    requiresToken: true,
  });
};

export const deleteBonus = async (BonusId: number) => {
  return httpClient.delete<BonusResponse>({
    url: `/v1/admin/Bonus/${BonusId}`,
    requiresToken: true,
  });
};

export const getBonusTypes = async () => {
  return httpClient.get<DataResponse<BonusTypes[]>>({
    url: '/v1/Bonus/Types',
    requiresToken: true,
  });
};

export const getBonusFrequencies = async () => {
  return httpClient.get<DataResponse<BonusFrequency[]>>({
    url: '/v1/Bonus/Frequencies',
    requiresToken: true,
  });
};

export const getPendingBonuses = async () => {
  return httpClient.get<DataResponse<Bonus[]>>({
    url: '/v1/Bonus/Pending',
    requiresToken: true,
  });
};

export const approvePendingBonus = async (BonusId: number) => {
  return httpClient.post<BonusResponse>({
    url: `/v1/admin/Bonus/${BonusId}/Approve`,
    requiresToken: true,
  });
};

export const rejectPendingBonus = async (BonusId: number, rejectRequest: RejectWithFeedbackRequest) => {
  return httpClient.post<BonusResponse>({
    url: `/v1/admin/Bonus/${BonusId}/Reject`,
    payload: rejectRequest,
    requiresToken: true,
  });
};
